import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareOrderAttributePropertyValues =
    AttributePropertyValues
    & {
        order: number;
    };

export type ClientAwareOrderAttributeProperties = {
    [name in keyof ClientAwareOrderAttributePropertyValues]?: ClientAwareOrderAttributePropertyValues[name];
};

export interface IClientAwareOrderAttribute extends IAttribute, ClientAwareOrderAttributeProperties
{
}

export class ClientAwareOrderAttribute extends Attribute implements IClientAwareOrderAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareOrderAttribute";
    public static override className = "ClientAwareOrderAttribute";

    public order?: number;

    constructor(propertyValues?: Partial<ClientAwareOrderAttributePropertyValues>)
    {
        super(propertyValues);

        this.order = propertyValues?.order;
    }
}